exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#container[data-v-5b6ef17c] {\n    width: 100%;\n    height: 100%;\n    top:0;\n    left: 0;\n    position: fixed;\n    z-index: 9998;\n    background: rgba(0,0,0, 0.5);\n}\n.popup_bg[data-v-5b6ef17c] {\n    width: 100%;\n    height: 100%;\n    top:0;\n    left: 0;\n    position: fixed;\n    z-index: 9999;\n    background: rgba(0,0,0, 0.5);\n}\n#closeVideo[data-v-5b6ef17c] {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    z-index: 100000;\n}\n#html5video[data-v-5b6ef17c] {\n    position: absolute;\n    top: 0px;\n    right: 0px;\n    bottom: 0px;\n    left: 0px;\n    max-height: 100%;\n    max-width: 100%;\n    margin: auto;\n    z-index: 100000;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b6ef17c","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/player/AudioPlayer.vue
// module id = MAEp
// module chunks = 2 3 4 5 6